import {resolveGpsForSubmit} from "@/src/modules/core/lib/resolve-gps-coordinates-string";
import {getShiftPrimaryPropertyGps} from "@/src/modules/shifts/lib/get-shift-primary-property-gps";
import type {ResolvedGpsPayload} from "@/src/modules/core/types/geolocation";
import type {Shift} from "@/src/modules/shifts/types";

export async function resolveShiftGpsForSubmit(
  shift: Shift | null | undefined,
  operation?: string,
): Promise<ResolvedGpsPayload | null> {
  return resolveGpsForSubmit(
    {
      propertyCoordinates: getShiftPrimaryPropertyGps(shift),
    },
    {
      onFailure: "toast",
      captureContext: operation ? {feature: "shifts", operation} : undefined,
    },
  );
}

/** @deprecated Prefer `resolveShiftGpsForSubmit` when `gps_source` is needed. */
export async function resolveShiftGpsCoordinates(
  shift: Shift | null | undefined,
): Promise<string | null> {
  const resolved = await resolveShiftGpsForSubmit(shift);
  return resolved?.gps_coordinates ?? null;
}
